import { mediaQuery } from 'constants/ui';

import {
  AI_ASSISTANT_DRAWER_WIDTH,
  AI_ASSISTANT_DRAWER_Z_INDEX,
} from '../../AiAssistant.constants';

export const drawerRootStyles = {
  zIndex: AI_ASSISTANT_DRAWER_Z_INDEX,
};

export const drawerPaperStyles = {
  width: `${AI_ASSISTANT_DRAWER_WIDTH}px`,
  maxWidth: '100vw',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxShadow: '-4px 0 18px rgba(0,0,0,0.08)',
  zIndex: AI_ASSISTANT_DRAWER_Z_INDEX,
  [mediaQuery.mobileAndTablet]: {
    width: '100vw',
  },
};
